import { useTranslation } from "react-i18next";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@material-ui/core";
import styled from "styled-components";
import type { MalwareContent, MalwareFile } from "@dashboard-v3/api";
import ListHeader from "./ListHeader";
import ThreatRow from "./ThreatRow";

interface Props {
  contents: MalwareContent[];
  expandedChecksum: string | null;
  extraFiles: Record<string, MalwareFile[]>;
  loadingFilesOf: string | null;
  onToggle: (content: MalwareContent) => void;
  onShowAllFiles: (content: MalwareContent) => void;
  onFileClick: (file: MalwareFile, content: MalwareContent) => void;
  onRelease: (content: MalwareContent) => void;
}

export default function List({
  contents,
  expandedChecksum,
  extraFiles,
  loadingFilesOf,
  onToggle,
  onShowAllFiles,
  onFileClick,
  onRelease,
}: Props) {
  const { t } = useTranslation("mxheroShares");

  const rows = contents.map(content => (
    <ThreatRow
      key={content.checksum}
      content={content}
      expanded={expandedChecksum === content.checksum}
      files={extraFiles[content.checksum] ?? content.files}
      loadingFiles={loadingFilesOf === content.checksum}
      onToggle={onToggle}
      onShowAllFiles={onShowAllFiles}
      onFileClick={onFileClick}
      onRelease={onRelease}
    />
  ));

  const noResults = (
    <TableRow>
      <TableCell colSpan={6}>
        <Typography
          variant="body2"
          color="textSecondary"
          align="center"
          style={{ padding: "30px 0" }}
        >
          {t("malware.list.noResults")}
        </Typography>
      </TableCell>
    </TableRow>
  );

  return (
    <TableContainer component={Paper}>
      <Table size="small" data-testid="malware-list">
        <ListHeader />
        <StyledTableBody>{contents.length ? rows : noResults}</StyledTableBody>
      </Table>
    </TableContainer>
  );
}

const StyledTableBody = styled(TableBody)`
  tr {
    background-color: white;
  }
`;
